'use client';

import { useMemo } from 'react';
import { trackWithCommonMetadata, TransformerMap } from './tracker';
import useAnalyticsCommonMetadataSession from './common-metadata/useAnalyticsCommonMetadataSession';
import useAnalyticsCommonMetadataUser from './common-metadata/useAnalyticsCommonMetadataUser';
import {
  useFactoringUpsellEntryPoint,
  useFactoringUpsellEntryPointImpression,
} from '../../(authenticated)/(carrier)/(marketplace)/_ui/FactoringUpsell/FactoringUpsellEntryPointProvider';

type FactoringUpsellAnalyticsEventMetadata = {
  FACTORING_UPSELL_ENGAGEMENT:
    | { action: 'accept' }
    | { action: 'decline'; reason: string };
};

/** Metadata transformers for each event, if applicable. */
const factoringUpsellAnalyticsEventMetadataTransformers: TransformerMap<FactoringUpsellAnalyticsEventMetadata> =
  {};

export default function useTrackAnalyticsEventFactoringUpsell() {
  const userMetadata = useAnalyticsCommonMetadataUser();
  const sessionMetadata = useAnalyticsCommonMetadataSession();
  const entryPoint = useFactoringUpsellEntryPoint();
  const { data } = useFactoringUpsellEntryPointImpression();
  const viewCount = data?.viewCount ?? 1;

  return useMemo(
    () =>
      trackWithCommonMetadata(
        [userMetadata, sessionMetadata, { entryPoint, viewCount }],
        factoringUpsellAnalyticsEventMetadataTransformers,
      ),
    [userMetadata, sessionMetadata, entryPoint, viewCount],
  );
}
